// jQuery를 Summernote보다 먼저 전역 등록 (최우선 import)
import '@/plugins/jquery-global';

import { createApp } from 'vue';

import App from '@/App.vue';
import { registerPlugins } from '@core/utils/plugins';

import { setupCalendar } from 'v-calendar';
import 'v-calendar/style.css';
import VCalendar from 'v-calendar';
// Styles
import '@core/scss/template/index.scss';
import '@layouts/styles/index.scss';
import '@/assets/styles/global.scss';
import '@/assets/styles/tailwind.css';
import vue3GoogleLogin from 'vue3-google-login';
import { useUserStore } from '@/stores/userStore';

// 테스트 사이트 여부 플래그 (DEV 서버 또는 env 플래그)
const isTestSite = import.meta.env.VITE_TEST_SITE === 'true' || import.meta.env.DEV;

// 테스트 사이트에서는 브라우저 탭 제목과 파비콘에 [테스트] 표시
if (isTestSite) {
  document.title = '[테스트] 마이정토';

  const existingFavicon = document.querySelector<HTMLLinkElement>("link[rel~='icon']");

  if (existingFavicon) {
    existingFavicon.href = '/favicon_dev.png';
  } else {
    const newFavicon = document.createElement('link');
    newFavicon.rel = 'icon';
    newFavicon.href = '/favicon_dev.png';
    document.head.appendChild(newFavicon);
  }
}

// Create vue app
const app = createApp(App);

// Register plugins
registerPlugins(app);

// Use user store after plugins are registered (persistedstate로 자동 복원)
const userStore = useUserStore();

// 앱 시작 시 자동 로그인 체크
(async () => {
  // Refresh token이 있고 유효한 경우 자동 로그인 시도
  if (userStore.refreshToken && !userStore.isRefreshTokenExpired()) {
    //console.log('🔄 [App Init] Refresh token이 유효함, 자동 로그인 시도');
    try {
      const refreshSuccess = await userStore.refreshAccessToken();
      if (refreshSuccess) {
        //console.log('✅ [App Init] 자동 로그인 성공');
        userStore.setIsLogin(true);
      } else {
        //console.log('❌ [App Init] 자동 로그인 실패');
      }
    } catch (error) {
      console.error('❌ [App Init] 자동 로그인 중 오류:', error);
    }
  } else if (userStore.refreshToken && userStore.isRefreshTokenExpired()) {
    //console.log('⏰ [App Init] Refresh token이 만료됨, 저장된 데이터 정리');
    userStore.clearStore();
  }
})();

// VCalendar 설정
app.use(setupCalendar, {
  // locale: 'ko-KR',
  firstDayOfWeek: 0, // 0: 일요일, 1: 월요일
});

app.use(VCalendar, {});

app.use(vue3GoogleLogin, {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
});

// Mount vue app
app.mount('#app');
